import React from "react";
export const DataGridContext = React.createContext({
    onCellFocused: null,
    onCellKeyDown: null,
    focusRowKey: null,
    focusColumnKey: null,
    desiredVisibleRowIndex: null,
    desiredFocusRowKey: null,
    desiredFocusColumnKey: null,
    columns: null,
    dataRowKey: null,
});
